import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <div className="legal">
        <a
          href="https://onenet.gg/creator/sarahnokumo#impressum"
          target="_blank"
          rel="noopener noreferrer"
        >
          Impressum
        </a>
        <Link to="/datenschutz">Datenschutz</Link>
      </div>
    </footer>
  );
}

export default Footer;
